// extracted by mini-css-extract-plugin
export default {"root":"Clock_root__7lxbx"};